import {Injectable} from '@angular/core';
import {GroupRight} from '../models/group-right';
import {BaseService} from '../base.service';
import {HttpService} from '../http.service';
import {environment} from '../../environments/environment';

@Injectable()
export class GroupRightService extends BaseService {
  private api: string;

  /**
   * GroupRightService constructor
   *
   * @param {HttpService} http
   */
  constructor(private http: HttpService)
  {
    super();
    this.api = environment.api_url;
  }

  public getGroupRights()
  {
    return this.http.get(this.api + 'group-rights/get')
        .map(response => response.json() as GroupRight[])
  }

  public getGroupRightForModule(module: string, groupRights: GroupRight[])
  {
    let access = groupRights.filter(function (element, index, array) {
      return element.module_code === module;
    });

    if (access.length > 0 ) {
      return access[0];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/group-right.service.ts